var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-04"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4082 3.84424C14.9992 5.00339 16.0332 6.88104 16.0332 9.0002C16.0332 12.521 13.179 15.3752 9.6582 15.3752H9.2832M5.9082 14.1561C4.3172 12.997 3.2832 11.1193 3.2832 9.0002C3.2832 5.47938 6.13739 2.6252 9.6582 2.6252H10.0332M10.4082 16.8002L8.9082 15.3002L10.4082 13.8002M8.9082 4.2002L10.4082 2.7002L8.9082 1.2002",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4082 3.84424C14.9992 5.00339 16.0332 6.88104 16.0332 9.0002C16.0332 12.521 13.179 15.3752 9.6582 15.3752H9.2832M5.9082 14.1561C4.3172 12.997 3.2832 11.1193 3.2832 9.0002C3.2832 5.47938 6.13739 2.6252 9.6582 2.6252H10.0332M10.4082 16.8002L8.9082 15.3002L10.4082 13.8002M8.9082 4.2002L10.4082 2.7002L8.9082 1.2002",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw04);
export default __webpack_public_path__ + "static/media/refresh-cw-04.425c2a79aef72122adc784bf65fccf38.svg";
export { ForwardRef as ReactComponent };